<template>
  <div>
    <ValidationProvider
      v-if="hasValidator"
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors }">
        <b-field
          v-bind="$attrs"
          :type="{ 'is-danger': errors[0] }"
          :message="errors">
            <b-taginput
                v-model="selectedRider"
                :data="filterRiders"
                autocomplete
                :open-on-focus="true"
                type="is-primary"
                :maxtags="1"
                :has-counter="false"
                icon="label"
                placeholder="Selecciona un Jinete"
                ref="taginput"
                @typing="rider = $event" :loading="isLoadingRiders">
                <template slot-scope="props">
                  {{props.option.lastname}} {{props.option.name}}
                </template>
                <template slot="empty">
                  No se encontraron elementos
                </template>
                <template slot="selected" slot-scope="props">
                    <b-tag
                        v-for="(tag, index) in props.tags"
                        :key="index"
                        type="is-primary"
                        :tabstop="false"
                        ellipsis
                        closable
                        @close="$refs.taginput.removeTag(index, $event)">
                        {{ tag.lastname }} {{tag.name}}
                    </b-tag>
                </template>
            </b-taginput>
        </b-field>
    </ValidationProvider>
    <b-autocomplete
        v-else
        v-model="rider"
        placeholder="Selecciona un Jinete"
        :open-on-focus="true"
        :data="filterRiders"
        field="name"
        @select="option => selectedRider = option" :loading="isLoadingRiders"
        :custom-formatter="fullName">
        <template slot-scope="props">
          {{props.option.lastname}} {{props.option.name}}
        </template>
        <template slot="empty">Sin Jinetes</template>
    </b-autocomplete>
  </div>
</template>

<script>
import RiderService from '@/services/RiderService'

export default {
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    hasValidator: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: null
    },
    value: {
      required: false,
      default: null,
      type: Number
    },
    values: {
      required: false,
      default: () => [],
      type: Array
    },
    empty: {
      required: false,
      default: null,
      type: Boolean
    }
  },
  created () {
    this.getRiders()
  },
  data () {
    return {
      rider: '',
      selectedRider: null,
      riders: [],
      isLoadingRiders: false
    }
  },
  methods: {
    async getRiders () {
      this.isLoadingRiders = true

      if (this.values.length > 0 || this.empty) {
        this.riders = this.values
      } else {
        let response = await RiderService.getRiders(this.params)
        this.riders = response.data.data
      }

      if (this.hasValidator && this.value) {
        this.selectedRider = this.riders.filter((x) => x.id === this.value)
      } else if (this.value) {
        this.selectedRider = this.riders.filter((x) => x.id === this.value)[0]
        this.rider = this.selectedRider ? `${this.selectedRider.lastname} ${this.selectedRider.name}` : ''
      }
      this.isLoadingRiders = false
    },
    fullName (object) {
      return `${object.lastname} ${object.name}`
    }
  },
  computed: {
    filterRiders () {
      return this.riders.filter((rider) => {
        return `${rider.lastname} ${rider.name}`
          .toString()
          .toLowerCase()
          .indexOf(this.rider.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    selectedRider () {
      if (this.hasValidator) {
        this.$emit('select', this.selectedRider[0])
      } else {
        this.$emit('select', this.selectedRider)
      }
    },
    value () {
      if (!this.hasValidator && this.selectedRider && this.selectedRider.id !== this.value) {
        this.selectedRider = this.riders.filter((x) => x.id === this.value)[0]
      } else if (this.selectedRider && this.selectedRider.id !== this.value) {
        this.selectedRider = this.riders.filter((x) => x.id === this.value)
      }
    },
    values () {
      this.getRiders()
    }
  }

}
</script>
